import React from "react";
import { Grid, Typography } from "@material-ui/core";

const HeliReportResponsible = ({ responsible }) => {
  if (!responsible) return null;

  return (
    <Grid container item justifyContent="flex-start">
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            <Typography variant="h6">Responsible</Typography>
          </Grid>
          <Grid item>
            <Typography>{responsible.get("name")}</Typography>
          </Grid>
          <Grid item>
            <Typography>Phone: {responsible.get("phone")}</Typography>
          </Grid>
          <Grid item>
            <Typography>E-mail: {responsible.get("email")}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HeliReportResponsible;
